<template>
	<transition name="fade"><div v-if="count > 0" class="bulkbar"><span><b>{{ count.toLocaleString() }}</b> {{ label }}</span><slot></slot><button class="pill sm" @click="$emit('clear')">Clear</button></div></transition>
</template>

<script>
export default {
	name: 'PeBulkBar',
	props: {
		count: { type: Number, default: 0 },
		label: { type: String, default: 'selected' },
	},
}
</script>
